import { useState, useEffect } from 'react';
import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import useSWR from 'swr';
import { apiModes } from '../../utils/constants';
import getProductLineLetter from '../../utils/api/getProductLineLetter';
import isSSR from '../../utils/isSSR';
import { useApiHost, useAppName, useLanguage, usePageState } from '../../utils/sitecoreContext';
import { useCurrentProductLine } from '../SelectProductsContext/SelectProductsProvider';

const useAdditionalWarrantyFetch = selectedTrimId => {
  const [currentProductLine] = useCurrentProductLine();

  const [warranties, setWarranties] = useState(null);

  const appName = useAppName();
  const hondaRestApiHost = useApiHost();
  const language = useLanguage();
  const pageState = usePageState();

  const productLineLetter = getProductLineLetter.get(currentProductLine) || getProductLineLetter.get(appName);

  const apiPath = `models/${productLineLetter}/${apiModes[pageState]}/transmissions/${selectedTrimId}/warranties?AcceptLanguage=${language}`;
  const apiUrl = `https://${hondaRestApiHost}/${apiPath}`;

  const { data, error, isLoading } = useSWR(apiUrl, axios, { revalidateOnFocus: false });

  useEffect(() => {
    if (isSSR()) return;

    if (data) {
      setWarranties(camelcaseKeys(data.data, { deep: 'true' }));
    }
  }, [selectedTrimId, apiUrl, data]);

  return {
    warranties,
    warrantiesLength: warranties?.length,
    isFetching: isLoading,
    hasError: error,
  };
};

export default useAdditionalWarrantyFetch;
